// AUTO-GENERATED by generate-zod-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { z } from 'zod'

export const serviceKeySchema = z.object({
  id: z.string().max(100),
  orgId: z.string().max(100),
  workspaceId: z.string().max(100).optional(),
  userId: z.string().max(100).optional(),
  createdAt: z.string().max(200).datetime(),
  updatedAt: z.string().max(200).datetime(),
  metadata: z.record(z.string(), z.unknown()).optional(),
  extended: z.record(z.string(), z.unknown()).optional(),
  serviceName: z.string().max(200),
  publicKey: z.string().max(50000),
  fingerprint: z.string().max(200),
  archived: z.boolean(),
  tenantId: z.string().max(100).optional(),
})

export type ServiceKeyInput = z.infer<typeof serviceKeySchema>
